import { RegistrationStepContainer } from '@/modules/authentication/presentation/containers';

export const RegistrationStepScreen = () => {
	return <RegistrationStepContainer />;
};
